import { SET_MARKETING_REDUCER } from '../constants/get_lead_profile.constants';

const initialState = {
    loading: false,
    marketing: null,
    created_by: null,
    ref_lead_source: null,
    error: null,
};

export const Lead_marketing = (state = initialState, action) => {
    switch (action.type) {
    case SET_MARKETING_REDUCER:
        return {
            ...state,
            marketing: action.payload.marketing,
            created_by: action.payload.created_by,
            ref_lead_source: action.payload.ref_lead_source,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/marketing.reducer.js